<template>
  <div class="adult-stocks-uoload-form" v-loading.fullscreen.lock='loading'>
    <pt-form-item label="上传文件" labelWidth="100px" :required="true">
      <el-upload
        ref="excel"
        class="upload-demo"
        action="aa"
        :auto-upload="false"
        :multiple="false"
        :on-change="changHandler"
        :on-remove="removeHandler"
        :file-list="excel"
        v-model="form.excel" name="excel" v-validate="'required'" data-vv-as="上传文件">
        <el-button size="small" type="primary">点击上传</el-button>
        <br>
      </el-upload>
    </pt-form-item>
    <pt-form-item label="" labelWidth="100px">
      <a :href="$privateResourcesUrlDownload+'templates/出库上传文件模板.xlsx'">
        <el-button type="text">下载文件模版</el-button>
      </a>
    </pt-form-item>
    <el-dialog title="批量出库结果" :visible.sync="showDialog" width="50%">
      <h3>本次操作样本共{{handleRes.length}}个,成功{{handleRes.filter(e=>e.success).length}}个，失败<span style="color:red">{{handleRes.filter(e=>!e.success).length}}</span>个</h3>
      <div style="max-height:500px;overflow: auto;">
        <div class="msgBox" v-if="handleRes.filter(e=>e.success).length">
          <p>成功列表：</p>
          <p v-for="(item,index) in handleRes.filter(e=>e.success)" :key="index">
            {{item.message}}
          </p>
        </div>
        <div class="msgBox" v-if="handleRes.filter(e=>!e.success).length">
          <p>失败列表：</p>
          <p v-for="(item,index) in handleRes.filter(e=>!e.success)" :key="index">
            {{item.message}}
          </p>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showDialog = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { validate } from 'utils/validate'
import { formatDate } from '@/utils/formUtils'
export default {
  data () {
    return {
      uploadForm: new FormData(),
      loading: false,
      form: {
        excel: []
      },
      excel: [],
      showDialog: false,
      handleRes: []
    }
  },
  watch: {
    reportFile: {
      handler: function (val, old) {
        if (val.length > 1) {
          this.reportFile = val.slice(-1)
        }
      }
    }
  },
  methods: {
    formatDate,
    formValidate () {
      return validate(this, this.form)
    },
    changHandler (file, fileList) {
      if (fileList.length > 1) {
        fileList.shift()
      }
      this.excel = fileList
      this.form.excel = fileList
    },
    removeHandler (file, fileList) {
      this.excel = fileList
      this.form.excel = fileList
    },
    uploadSubmit () {
      this.formValidate().then(_ => {
        this.loading = true
        this.uploadForm = new FormData()
        this.uploadForm.append('excel', this.excel[0].raw)
        this.$store.dispatch('outboundByUpload', this.uploadForm).then(data => {
          this.excel[0].status = 'ready'
          this.loading = false
          this.showDialog = true
          this.handleRes = data
        }).catch((error) => {
          this.loading = false
          this.lotForm.excel[0].status = 'ready'
          this.excel[0] = this.lotForm.excel[0]
          this.$message.error(error)
        })
      })
    }
  }
}
</script>

<style lang="less">
.adult-stocks-uoload-form{
  .el-upload-list{
    max-width: 800px;
  }
  .el-dialog__body{
    padding: 0rem 0.2rem;
  }
}
</style>
